/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { RequestSecuritySettingsResponse } from './RequestSecuritySettingsResponse.types.tsx';

const RESOURCE_TYPE_CUSTOMER_PERMISSIONS = 'CUSTOMER_PERMISSIONS';

export const customerPermissionsPageDataResource: RouteResource<RequestSecuritySettingsResponse> =
	createResource<RequestSecuritySettingsResponse>({
		type: RESOURCE_TYPE_CUSTOMER_PERMISSIONS,
		getKey: ({ match }) => match.params.projectKey || '',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-customer-permissions", jiraSpaEntry: "async-resource-customer-permissions" */ './getData.tsx'
			),
		maxAge: Infinity,
	});
